export default __webpack_public_path__ + "static/media/Ficha Técnica  - Goiaba Organico Asséptico.d0e93835.pdf";